export interface EmbedAuthConfig {
  accessToken?: string | null;
  apiBaseUrl?: string | null;
}

let embedAuthConfig: EmbedAuthConfig = {};

export const setEmbedAuthConfig = (config: EmbedAuthConfig): void => {
  embedAuthConfig = {
    accessToken: config.accessToken ?? null,
    apiBaseUrl: config.apiBaseUrl ?? null,
  };
};

export const clearEmbedAuthConfig = (): void => {
  embedAuthConfig = {};
};

export const getEmbedAccessToken = (): string | null => embedAuthConfig.accessToken?.trim() || null;

export const getEmbedApiBaseUrl = (): string | null => embedAuthConfig.apiBaseUrl?.trim() || null;

export const isEmbedAuthEnabled = (): boolean => Boolean(getEmbedAccessToken());
